import React from "react";
import * as PropTypes from "prop-types";
import DescriptionPanel from "../Shared/DescriptionPanel/DescriptionPanel";
import DescriptionRow from "../Shared/DescriptionPanel/DescriptionRow";

const AgilentGCDescriptionPanel = (props) => (
  <DescriptionPanel>
    <DescriptionRow
      title="Instrument ID"
      value={props.instrumentInfo.name}
      icon="hashtag"
    />

    <DescriptionRow
      title="Type"
      value="Agilent Gas Chromatography System"
      icon="cube"
    />

    <DescriptionRow
      title="Serial Number"
      value={props.instrumentInfo.current_serial_number}
      icon="laptop"
    />

    <DescriptionRow
      title="Location"
      value={props.instrumentInfo.location}
      icon="map-marker"
    />
  </DescriptionPanel>
);

AgilentGCDescriptionPanel.propTypes = {
  instrumentInfo: PropTypes.object.isRequired,
};

export default AgilentGCDescriptionPanel;
